"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const AccessibilityModels_1 = require("../../Models/AccessibilityModels");
const ServiceImplBase_1 = require("./ServiceImplBase");
class AccessibilityServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "accessibility" /* Accessibility */;
    }
    getTooltipTextAsync(visualId, tupleId) {
        let tooltipTextRequest = new AccessibilityModels_1.TooltipTextRequestModel(visualId, tupleId);
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'getTooltipTextAsync',
            [api_internal_contract_js_1.ParameterId.TooltipTextRequest]: tooltipTextRequest,
        };
        return this.execute(api_internal_contract_js_1.VerbId.GetTooltipText, parameters).then((response) => {
            return response.result;
        });
    }
    leaveMarkNavigationAsync(visualId) {
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'leaveMarkNavigationAsync',
            [api_internal_contract_js_1.ParameterId.VisualId]: visualId,
        };
        return this.execute(api_internal_contract_js_1.VerbId.RaiseLeaveMarkNavNotification, parameters).then((response) => {
            return;
        });
    }
}
exports.AccessibilityServiceImpl = AccessibilityServiceImpl;
//# sourceMappingURL=AccessibilityServiceImpl.js.map